export const accountTypes = {
    BUSINESS: "Business",
    RESIDENTIAL: "Residential"
};

export const accountTypesArray = [
    accountTypes.BUSINESS,
    accountTypes.RESIDENTIAL
];
